import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";

function CtaOffer() {
  return (
    <div className="flex flex-col gap-2 rounded-xl bg-yellow w-full overflow-hidden lg:sticky lg:top-12">
      <img
        src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/offer-cta.png"
        alt="Drzewus - usługi ogrodnicze - zapytaj o wycenę"
      />
      <div className="flex flex-col items-center justify-center p-6 gap-2">
        <p className="text-white text-2xl font-head">
          Masz pytania? Porozmawiajmy!
        </p>
        <a
          href=""
          className="hover:opacity-50 transition duration-300 ease-linear flex flex-row items-center text-white text-xl gap-2 justify-start"
        >
          <FaPhoneAlt />
          <span>+48 000 000 000</span>
        </a>
        <a
          href=""
          className="hover:opacity-50 transition duration-300 ease-linear flex flex-row items-center text-white text-xl gap-2 justify-end"
        >
          <IoMail />
          <span>kontakt@drzewus.pl</span>
        </a>
      </div>
    </div>
  );
}

export default CtaOffer;
